import styled from 'styled-components'
import Link from '../Link'
import Image from '../Image'
import { StyledActivityTypes } from './Activity'

function ActivityTile( { activity } ) {
  const image = activity.activityImage[ 0 ] || null

  return (
    <StyledActivityTile>
      <Link href={ `/lets-make/${ activity.slug }` }>
        { image && (
          <StyledBgImage>
            <Image
              src={ image.url }
              alt=""
              layout="fill"
              objectFit="cover"
              objectPosition={ `${ image.focalPoint[ 0 ] * 100 }% ${ image.focalPoint[ 1 ] * 100 }%` }
            />
          </StyledBgImage>
        ) }
        <h2>{ activity.title }</h2>
        { activity.subHeading && <p>{ activity.subHeading }</p> }
        { activity.activityType?.length > 0 && (
          <StyledActivityTypes>
            { activity.activityType.map( activityType => (
              <span key={ activityType.id }>{ activityType.title }</span>
            ) ) }
          </StyledActivityTypes>
        ) }
      </Link>
    </StyledActivityTile>
  )
}

const StyledActivityTile = styled.div`
  position: relative;
  display: flex;

  > a {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    aspect-ratio: 1;
    /* min-height: calc( 8.678em - ( ${ p => p.theme.typo.sizes.large } * 2 ) ); */
    flex-direction: column;
    padding: ${ p => p.theme.typo.sizes.large };
    color: ${ p => p.theme.colors.white };
    text-decoration: none;
    font-size: ${ p => p.theme.typo.sizes.large };

    > h2 {
      position: relative;
      margin: 0;
      ${ p => p.theme.typo.neueHaasBold };
      font-size: inherit;
    }

    > p {
      position: relative;
      margin: 0 0 2rem 0;
      font-size: inherit;
    }

    @media ( max-width: 500px ) {
      font-size: ${ p => p.theme.typo.sizes.medium };
    }
  }

  ${ StyledActivityTypes } {
    margin-top: auto;
  }
`

const StyledBgImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  img {
    filter: grayscale( 1 );
  }
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: ${ p => p.theme.colors.grey4 };
    opacity: 0.9;
  }
`

export default ActivityTile
